module.exports = __webpack_public_path__ + "static/media/rss-sert.8e32ef69.jpg";